module.exports = __webpack_public_path__ + "static/media/payrollTransferHistory.213722a6.svg";